import angular from 'angular';
import contractsComponent from './contracts.component';

let contractsModule = angular.module('contracts', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('contracts', contractsComponent);

export default contractsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/contracts/contracts.js